import { createContext } from "react";

import type {
  CookieConsentCategory,
  CookieConsentPreferences,
  StoredCookieConsent,
} from "@/lib/cookie-consent";

export type CookieConsentContextType = {
  consent: StoredCookieConsent | null;
  hasAnswered: boolean;
  preferences: CookieConsentPreferences;
  isCategoryEnabled: (category: CookieConsentCategory) => boolean;
  acceptAll: () => void;
  rejectOptional: () => void;
  savePreferences: (preferences: Partial<Omit<CookieConsentPreferences, "necessary">>) => void;
  openPreferences: () => void;
  closePreferences: () => void;
  isPreferencesOpen: boolean;
};

export const CookieConsentContext = createContext<CookieConsentContextType | null>(null);
